import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    provideAnimations(),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'sr-Latn' },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'sr',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [MatIconRegistry, DomSanitizer],
      useFactory: (icons: MatIconRegistry, sanitizer: DomSanitizer) => () => {
        const editUrl = sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pencil.svg');
        const delUrl = sanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg');
        icons.addSvgIcon('edit-custom', editUrl);
        icons.addSvgIcon('delete-custom', delUrl);
        return Promise.resolve();
      }
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [HttpClient, TranslateService],
      useFactory: (http: HttpClient, translate: TranslateService) => () =>
        Promise.all([
          http.get<Record<string, any>>('assets/i18n/react-en.json').toPromise().catch(() => ({})),
          http.get<Record<string, any>>('assets/i18n/react-sr.json').toPromise().catch(() => ({}))
        ]).then(([enCompat, srCompat]) => {
          if (enCompat && Object.keys(enCompat).length) translate.setTranslation('en', enCompat, true);
          if (srCompat && Object.keys(srCompat).length) translate.setTranslation('sr', srCompat, true);
          translate.setDefaultLang('sr');
          translate.use('sr');
        })
    }
  ]
};
